import {GET_VERIFICATION_DOCUMENT_LIST, GET_VERIFICATION_DOCUMENT_LIST_SUCCESS,GET_VERIFICATION_DOCUMENT_LIST_FAILED,
    GET_VERIFICATION_DOCUMENT_VIEW_DETAILS,GET_VERIFICATION_DOCUMENT_VIEW_DETAILS_SUCCESS,GET_VERIFICATION_DOCUMENT_VIEW_DETAILS_FAILED} from './actionType'

export const getDocumentListData = (json)=>{
    return{
        type:GET_VERIFICATION_DOCUMENT_LIST,
        payload: {json}
    }
}

export const getDocumentListDataSuccess = (json)=>{
    return{
        type:GET_VERIFICATION_DOCUMENT_LIST_SUCCESS,
        payload: json
    }
}


export const getDocumentListDataFail = (json)=>{
    return{
        type: GET_VERIFICATION_DOCUMENT_LIST_FAILED,
        payload: json
    }
}

// view document status
export const getviewDocumentListData = (json)=>{
    return{
        type:GET_VERIFICATION_DOCUMENT_VIEW_DETAILS,
        payload: {json}
    }
}

export const getviewDocumentListDataSuccess = (json)=>{
    return{
        type:GET_VERIFICATION_DOCUMENT_VIEW_DETAILS_SUCCESS,
        payload: json
    }
}


export const getviewDocumentListDataFail = (json)=>{
    return{
        type: GET_VERIFICATION_DOCUMENT_VIEW_DETAILS_FAILED,
        payload: json
    }
}